import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PARSE from 'html-react-parser';
import store from '../../context/store';
import { Link } from 'react-router-dom';
import Api from './Api';

function SSoft_Solutions_More_Info() {
  const [sectionItems, setSectionItems] = useState([]);
  const [pdfFile, setPdfFile] = useState();
  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const { widget_contents } = sectionResponse.data?.results[0]?.widgets[0];
      const data = sectionResponse.data?.results[0]?.widgets[1]?.widget_contents[0]?.file;

      setSectionItems(widget_contents);
      setPdfFile(data);
    };

    fetchData();
  }, [activeLang]);

  return (
    <div className="section-container w-full h-full xl:px-[120px]">
      <div className="w-full min-h-[280px] grid grid-cols-1 gap-y-2.5 mdl:gap-y-0 mdl:grid-cols-3">
        {sectionItems &&
          sectionItems.map((data) => {
            const { title, summary, content, path } = data?.article_language;
            const { file_small } = data?.assets[0];

            return (
              <div
                key={data.id}
                className="relative w-full min-h-[280px] hdxl:min-h-[290px] hd3xl:min-h-[300px] p-[30px] mdl:p-[20px] xl:p-[30px] hdl:p-[45px]"
                style={{
                  backgroundImage: `url(${file_small})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'right center',
                }}
              >
                <div className="relative z-50 w-full h-full flex flex-col justify-between items-start">
                  <div className="space-y-[15px]">
                    <h1 className="text-cuzWhite text-[30px] hdxl:text-[32px] hd3xl:text-[34px] font-bold">{title}</h1>
                    <h2 className="text-cuzWhite w-full xs:w-[250px]">{PARSE(content)}</h2>
                  </div>
                  {summary !== 'Download' ? (
                    <Link
                      to={path}
                      className="relative z-10 white-button h-[48px] cursor-pointer text-[16px] hdxl:text-[18px] hd3xl:text-[20px] flex justify-center items-center"
                      onClick={() => store.dispatch({ type: 'topicStore/setTopicValue', payload: summary === 'Try Demo' ? 'Request Demo' : 'Sales' })}
                    >
                      {summary}
                    </Link>
                  ) : (
                    <a
                      href={pdfFile}
                      className="relative z-10 white-button h-[48px] cursor-pointer text-[16px] flex justify-center items-center hdxl:text-[18px] hd3xl:text-[20px]"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {summary}
                    </a>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default SSoft_Solutions_More_Info;
